import {
  List,
  ListItem,
  ListItemText,
  Paper,
  Select,
  TextField,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Divider,
  Button,
  IconButton,
  InputBase,
  Collapse,
  Grid,
  FormLabel,
} from "@material-ui/core";
import DateFnsUtils from "@date-io/date-fns";
import Autocomplete from "@material-ui/lab/Autocomplete";
import zhLocale from "date-fns/locale/zh-CN";
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import {
  Search,
  Settings,
  DateRange,
  MyLocation,
  WifiTethering,
  ExpandLess,
  ExpandMore,
} from "@material-ui/icons";
import { withStyles } from "@material-ui/core/styles";
import "date-fns";
import "fontsource-roboto";
import React, { Component } from "react";
import { formateDateSlash, encodePacent } from "../utils/utilTools";

require("../assets/css/style.css");

const useStyles = {
  root: {
    "& > *": {
      paddingTop: "0px",
      paddingBottom: "0px",
      fontSize: "14px",
    },
  },
  inputText: {
    margin: "0 5px 0 0",
    background: "#FFFFFF",
    borderRadius: "4px",
    border: "1px solid #D0D7DD",
  },
  selectText: {
    height: "40px",
    margin: "0 5px 0 0",
    background: "#FFFFFF",
    borderRadius: "4px",
    border: "1px solid #D0D7DD",
  },
  breakLine: {
    margin: "20px 0 0 0",
  },
  breakLineInset: {
    margin: "20px 0 0 16px",
  },
  iconButton: {
    padding: "10px",
    color: "#5d5dcc",
  },
};

class SearchDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      keyword: "",
      showList: [],
      listIndex: 0,
      date: false,
      selectedDate: new Date(),
      categoryValue: "1",
      pagesize: "10",
      fwOptions: [],
      fwValues: "1",
      randomMean: new Date().getTime(),
      datepick: new Date().getTime(),
      collapseCheck: [],
    };
  }

  componentDidMount() {
    let arr = [];
    for (let index = 0; index < 4; index++) {
      arr[index] = false;
    }
    this.setState({
      collapseCheck: arr,
    });
  }

  setchecked = (index) => {
    let arr = this.state.collapseCheck;
    for (let i = 0; i < 4; i++) {
      if (index === i) {
        arr[i] = !this.state.collapseCheck[i];
      } else {
        arr[i] = false;
      }
    }
    this.setState({
      collapseCheck: arr,
    });
  };

  handleFwChange(ev) {
    this.setState({
      fwValues: ev.target.value,
    });
  }

  handleCategoryChange(ev) {
    this.setState({
      categoryValue: ev.target.value,
    });
  }

  handleSsszChange(name, ev) {
    var gjssform = this.props.initData;
    gjssform[name] = ev.target.value;
    if (name === "zdfw") {
      this.setState({
        randomMean: new Date().getTime(),
      });
    }
    if (name === "sjfw") {
      gjssform["sjfw_to"] = formateDateSlash(new Date().getTime());
      if (gjssform.sjfw === "4") {
        gjssform["sjfw_from"] = formateDateSlash(new Date().getTime());
      } else if (gjssform.sjfw === "2") {
        var from = 0;
        var today = new Date();
        if (today.getMonth() + 1 === 1) {
          today = today.setMonth(12);
          today = today.setFullYear(today.getFullYear() - 1);
          from = today;
        } else {
          today = today.setMonth(today.getMonth() - 1);
          from = today;
        }
        gjssform["sjfw_from"] = formateDateSlash(from);
      } else if (gjssform.sjfw === "1") {
        var from = 0;
        var today = new Date();
        today = today.setFullYear(today.getFullYear() - 1);
        from = today;
        gjssform["sjfw_from"] = formateDateSlash(from);
      } else if (gjssform.sjfw === "0") {
        gjssform["sjfw_from"] = formateDateSlash(new Date("1900/01/01"));
        gjssform["sjfw_to"] = formateDateSlash(new Date().getTime());
      }
    }
    this.props.CustomSetter(gjssform);
  }

  handleZdfwChange(option, ev) {
    let value = "";
    if (option) {
      value = option.value;
    } else {
      value = "0";
    }
    var gjssform = this.props.initData;
    gjssform["zdfw"] = value;
    this.props.CustomSetter(gjssform);
  }

  handleZwgkChange(name, ev) {
    var zwgkform = this.props.xxgkData;
    zwgkform[name] = ev.target.value;
    if (name === "cwrq_from" || name === "cwrq_to") {
      if (new Date(zwgkform.cwrq_from) > new Date(zwgkform.cwrq_to)) {
        return;
      }
    }
    this.props.ZwgkSetter(zwgkform);
  }

  handleZwgkSelChange(name, ev) {
    var zwgkform = this.props.xxgkData;
    zwgkform[name] = ev.target.innerText;
    if (name === "cwrq_from" || name === "cwrq_to") {
      if (new Date(zwgkform.cwrq_from) > new Date(zwgkform.cwrq_to)) {
        return;
      }
    }
    this.props.ZwgkSetter(zwgkform);
  }

  // 修改高级搜索时间范围
  handleDateChange(name, ev) {
    var gjssform = this.props.initData;
    gjssform[name] = formateDateSlash(ev.getTime());
    if (name === "sjfw_from" || name === "sjfw_to") {
      gjssform["sjfw"] = "4";
      if (!gjssform.sjfw_to) {
        gjssform["sjfw_to"] = formateDateSlash(new Date().getTime());
      }
      if (!gjssform.sjfw_from) {
        gjssform["sjfw_from"] = formateDateSlash(new Date().getTime());
      }
      if (new Date(gjssform.sjfw_from) > new Date(gjssform.sjfw_to)) {
        alert("开始时间不能大于结束时间！");
        return;
      }
    }
    this.props.CustomSetter(gjssform);
  }

  handleCwrqChange(name, ev) {
    var zwgkform = this.props.xxgkData;
    zwgkform[name] = formateDateSlash(ev.getTime());
    if (name === "cwrq_from" || name === "cwrq_to") {
      if (new Date(zwgkform.cwrq_from) > new Date(zwgkform.cwrq_to)) {
        return;
      }
    }
    this.props.ZwgkSetter(zwgkform);
  }
  handleRest() {
    this.setState({
      randomMean: new Date().getTime(),
    });
    this.props.CustomReSetter();
  }

  handleSearchInput(ev) {
    this.props.handleCusSearchInput(ev.target.value);
  }

  handleKeyEnter(ev) {
    var keyCode = ev.keyCode;
    if (keyCode === 13) {
      this.props.handleSearchClick();
    }
  }
  render() {
    const _this = this;
    const {
      flag,
      classes,
      cuskeyword,
      initData,
      xxgkData,
      handleSearchClick,
      isTop,
    } = this.props;

    const fwelements = [];
    initData &&
      initData.fwOptions &&
      initData.fwOptions.zdfw.forEach((item) => {
        fwelements.push(
          <FormControlLabel
            value={item.value}
            control={<Radio color="primary" />}
            label={item.name}
          />
        );
      });
    const zdfw = (
      <RadioGroup
        row
        aria-label="position"
        name="position"
        value={initData.zdfw}
        onChange={_this.handleSsszChange.bind(this, "zdfw")}
      >
        <FormControlLabel
          value="0"
          control={<Radio color="primary" />}
          label="不限"
        />
        {fwelements}
      </RadioGroup>
    );

    const fw =
      initData && initData.fwOptions && initData.fwOptions.zdbm ? (
        <Autocomplete
          key={this.state.randomMean}
          style={{ width: isTop ? 230 : 300 }}
          size="small"
          id="zdfw-autocomplet"
          options={initData.fwOptions.zdbm.map((option) => option)}
          getOptionLabel={(option) => option.name}
          renderInput={(params) => (
            <TextField
              {...params}
              label="选择部门站点"
              margin="normal"
              variant="outlined"
            />
          )}
          onChange={(event, value) => _this.handleZdfwChange(value)}
        />
      ) : (
        ""
      );

    const fbjgelements = [];
    xxgkData &&
      xxgkData.organizations &&
      xxgkData.organizations.forEach((item) => {
        fbjgelements.push(<option value={item}>{item}</option>);
      });

    const wzelements = [];
    xxgkData &&
      xxgkData.groups &&
      xxgkData.groups.forEach((item) => {
        wzelements.push(<option value={item}>{item}</option>);
      });

    return (
      <Grid container spacing={1}>
        {isTop ? (
          <Paper elevation={0} className="dialog-i-top">
            <form className={classes.root} noValidate autoComplete="off">
              <FormControl className={classes.root} variant="outlined">
                <FormLabel style={{ marginBottom: 10 }}>搜索设置</FormLabel>
                <RadioGroup
                  row
                  aria-label="position"
                  name="position"
                  value={initData.sssz}
                  onChange={_this.handleSsszChange.bind(this, "sssz")}
                  style={{ marginLeft: "16px" }}
                >
                  <FormControlLabel
                    className="checkbox-width"
                    value="1"
                    control={<Radio color="primary" />}
                    label="模糊查询"
                  />
                  <FormControlLabel
                    className="checkbox-width"
                    value="2"
                    control={<Radio color="primary" />}
                    label="精确查询"
                  />
                </RadioGroup>
              </FormControl>
              <FormControl
                className={classes.root}
                variant="outlined"
                style={{ marginLeft: 140 }}
              >
                <FormLabel style={{ marginBottom: 10 }}>发布时间</FormLabel>
                <Select
                  style={{ marginLeft: "16px" }}
                  size="small"
                  className={classes.selectText}
                  native
                  value={initData.sjfw}
                  onChange={_this.handleSsszChange.bind(this, "sjfw")}
                  inputProps={{
                    name: "age",
                    id: "outlined-age-native-simple",
                  }}
                >
                  <option aria-label="none" value="0">
                    不限
                  </option>
                  <option value="1">一年内</option>
                  <option value="2">一个月内</option>
                  <option value="4">自定义</option>
                </Select>
              </FormControl>
              <FormControl
                className={classes.root}
                variant="outlined"
                style={{ marginLeft: 140 }}
              >
                <FormLabel style={{ marginBottom: 10 }}>搜索词位置</FormLabel>
                <RadioGroup
                  row
                  style={{ marginLeft: "16px" }}
                  aria-label="position"
                  name="position"
                  value={initData.sscwz}
                  onChange={_this.handleSsszChange.bind(this, "sscwz")}
                >
                  <FormControlLabel
                    className="checkbox-width"
                    value="1"
                    control={<Radio color="primary" />}
                    label="全文"
                  />
                  <FormControlLabel
                    className="checkbox-width"
                    value="2"
                    control={<Radio color="primary" />}
                    label="标题"
                  />
                </RadioGroup>
              </FormControl>
              <FormControl className={classes.root} variant="outlined">
                <FormLabel style={{ margin: "10px 0" }}>站点范围</FormLabel>
                {zdfw}
              </FormControl>
              <FormControl className={classes.root} variant="outlined">
                <FormLabel style={{ margin: "10px 0" }}></FormLabel>
                {fw}
              </FormControl>
            </form>
          </Paper>
        ) : (
          ""
        )}
        {isTop ? (
          ""
        ) : (
          <ListItem>
            <Paper component="form" className={classes.root}>
              <InputBase
                className={classes.input}
                placeholder="根据搜索设置进行精确查询"
                inputProps={{ "aria-label": "search google maps" }}
                onChange={this.handleSearchInput.bind(this)}
                onKeyDown={this.handleKeyEnter.bind(this)}
                value={cuskeyword}
                style={{
                  height: "48px",
                  width: "260px",
                  paddingLeft: "10px",
                }}
              />
              <IconButton
                className={classes.iconButton}
                aria-label="search"
                onClick={handleSearchClick}
              >
                <Search />
              </IconButton>
            </Paper>
          </ListItem>
        )}
        {isTop ? (
          ""
        ) : (
          <Grid
            style={{
              height: "50px",
              borderBottom: "1px solid #d1d1d1",
              marginTop: "-12px",
            }}
            item
            xs={8}
          >
            <p className="history-p">精准搜索</p>
          </Grid>
        )}
        {isTop ? (
          ""
        ) : (
          <Grid item xs={12}>
            <Paper elevation={0} className="dialog-i">
              <div>
                <List>
                  <form className={classes.root} noValidate autoComplete="off">
                    <ListItem
                      style={
                        this.state.collapseCheck[0]
                          ? { backgroundColor: "rgb(250 250 250)" }
                          : {}
                      }
                    >
                      <Collapse
                        in={this.state.collapseCheck[0]}
                        timeout="auto"
                        collapsedHeight={45}
                      >
                        <List>
                          <ListItem
                            button
                            target="_blank"
                            className="collage-listitemtitle"
                            onClick={() => this.setchecked(0)}
                          >
                            <Settings style={{ color: "#e7a83b" }} />
                            &ensp;
                            <ListItemText primary="搜索设置" />
                            {this.state.collapseCheck[0] ? (
                              <ExpandLess />
                            ) : (
                              <ExpandMore />
                            )}
                          </ListItem>
                        </List>
                        <FormControl
                          className={classes.root}
                          variant="outlined"
                        >
                          <RadioGroup
                            row
                            aria-label="position"
                            name="position"
                            value={initData.sssz}
                            onChange={_this.handleSsszChange.bind(this, "sssz")}
                            style={{ marginLeft: "16px" }}
                          >
                            <FormControlLabel
                              className="checkbox-width"
                              value="1"
                              control={<Radio color="primary" />}
                              label="模糊查询"
                            />
                            <FormControlLabel
                              className="checkbox-width"
                              value="2"
                              control={<Radio color="primary" />}
                              label="精确查询"
                            />
                          </RadioGroup>
                        </FormControl>
                      </Collapse>
                    </ListItem>
                    <ListItem
                      style={
                        this.state.collapseCheck[1]
                          ? { backgroundColor: "rgb(250 250 250)" }
                          : {}
                      }
                    >
                      <Collapse
                        in={this.state.collapseCheck[1]}
                        timeout="auto"
                        collapsedHeight={45}
                      >
                        <List>
                          <ListItem
                            button
                            target="_blank"
                            className="collage-listitemtitle"
                            onClick={() => this.setchecked(1)}
                          >
                            <DateRange style={{ color: "#e7a83b" }} />
                            &ensp;
                            <ListItemText primary="发布时间" />
                            {this.state.collapseCheck[1] ? (
                              <ExpandLess />
                            ) : (
                              <ExpandMore />
                            )}
                          </ListItem>
                        </List>
                        <FormControl variant="outlined">
                          <Select
                            style={{ marginLeft: "16px" }}
                            size="small"
                            className={classes.selectText}
                            native
                            value={initData.sjfw}
                            onChange={_this.handleSsszChange.bind(this, "sjfw")}
                            inputProps={{
                              name: "age",
                              id: "outlined-age-native-simple",
                            }}
                          >
                            <option aria-label="none" value="0">
                              不限
                            </option>
                            <option value="1">一年内</option>
                            <option value="2">一个月内</option>
                            <option value="4">自定义</option>
                          </Select>
                        </FormControl>
                        <br />
                        <MuiPickersUtilsProvider
                          utils={DateFnsUtils}
                          locale={zhLocale}
                        >
                          <KeyboardDatePicker
                            style={{ width: "150px" }}
                            margin="normal"
                            cancelLabel="取消"
                            okLabel="确定"
                            invalidDateMessage=""
                            format="yyyy/MM/dd"
                            showTodayButton={true}
                            todayLabel="今天"
                            maxDate={new Date()}
                            maxDateMessage="不得选择今天以后的日期"
                            value={initData.sjfw_from}
                            onChange={_this.handleDateChange.bind(
                              this,
                              "sjfw_from"
                            )}
                            KeyboardButtonProps={{
                              "aria-label": "change date",
                            }}
                          />
                          ～
                          <KeyboardDatePicker
                            style={{ width: "150px" }}
                            margin="normal"
                            cancelLabel="取消"
                            okLabel="确定"
                            invalidDateMessage=""
                            format="yyyy/MM/dd"
                            showTodayButton={true}
                            todayLabel="今天"
                            maxDate={new Date()}
                            maxDateMessage="不得选择今天以后的日期"
                            value={initData.sjfw_to}
                            onChange={_this.handleDateChange.bind(
                              this,
                              "sjfw_to"
                            )}
                            KeyboardButtonProps={{
                              "aria-label": "change date",
                            }}
                          />
                        </MuiPickersUtilsProvider>
                      </Collapse>
                    </ListItem>
                    <ListItem
                      style={
                        this.state.collapseCheck[2]
                          ? { backgroundColor: "rgb(250 250 250)" }
                          : {}
                      }
                    >
                      <Collapse
                        in={this.state.collapseCheck[2]}
                        timeout="auto"
                        collapsedHeight={45}
                      >
                        <List>
                          <ListItem
                            button
                            target="_blank"
                            className="collage-listitemtitle"
                            onClick={() => this.setchecked(2)}
                          >
                            <MyLocation style={{ color: "#e7a83b" }} />
                            &ensp;
                            <ListItemText primary="搜索词位置" />
                            {this.state.collapseCheck[2] ? (
                              <ExpandLess />
                            ) : (
                              <ExpandMore />
                            )}
                          </ListItem>
                        </List>
                        <FormControl variant="outlined">
                          <RadioGroup
                            row
                            style={{ marginLeft: "16px" }}
                            aria-label="position"
                            name="position"
                            value={initData.sscwz}
                            onChange={_this.handleSsszChange.bind(
                              this,
                              "sscwz"
                            )}
                          >
                            <FormControlLabel
                              className="checkbox-width"
                              value="1"
                              control={<Radio color="primary" />}
                              label="全文"
                            />
                            <FormControlLabel
                              className="checkbox-width"
                              value="2"
                              control={<Radio color="primary" />}
                              label="标题"
                            />
                          </RadioGroup>
                        </FormControl>
                      </Collapse>
                    </ListItem>
                    {flag !== "kb" ? (
                      <ListItem
                        style={
                          this.state.collapseCheck[3]
                            ? { backgroundColor: "rgb(250 250 250)" }
                            : {}
                        }
                      >
                        <Collapse
                          in={this.state.collapseCheck[3]}
                          timeout="auto"
                          collapsedHeight={45}
                        >
                          <List>
                            <ListItem
                              button
                              target="_blank"
                              className="collage-listitemtitle"
                              onClick={() => this.setchecked(3)}
                            >
                              <WifiTethering style={{ color: "#e7a83b" }} />
                              &ensp;
                              <ListItemText primary="站点范围" />
                              {this.state.collapseCheck[3] ? (
                                <ExpandLess />
                              ) : (
                                <ExpandMore />
                              )}
                            </ListItem>
                          </List>
                          <FormControl
                            style={{ marginLeft: "16px" }}
                            variant="outlined"
                          >
                            {zdfw}
                          </FormControl>
                          <FormControl
                            style={{ marginLeft: "16px" }}
                            variant="outlined"
                          >
                            {fw}
                          </FormControl>
                        </Collapse>
                      </ListItem>
                    ) : (
                      ""
                    )}
                  </form>
                </List>
              </div>
            </Paper>
          </Grid>
        )}
      </Grid>
    );
  }
}

export default withStyles(useStyles)(SearchDialog);
